// @flow

// Dynamic import uses promises

export function loadPolyfills(): Promise<any> {
  const polyfillsNeeded = {
    ES2015: !hasES2015(),
    INTERSECTION_OBSERVER: !hasIntersectionObserver(),
    OBJECT_FIT: !hasObjectFit()
  }
  return Promise.all(
    [
      Promise.resolve(polyfillsNeeded),
      polyfillsNeeded.ES2015 && import('core-js/shim'),
      polyfillsNeeded.INTERSECTION_OBSERVER && import('intersection-observer'),
      polyfillsNeeded.OBJECT_FIT && import('objectFitPolyfill')
    ].filter(Boolean)
  ).then(_ => {
    return polyfillsNeeded
  })
}

export function hasObjectFit() {
  const edgeVersion = window.navigator.userAgent.match(/Edge\/(\d{2})\./)
  const edgePartialSupport = edgeVersion ? parseInt(edgeVersion[1], 10) >= 16 : false
  const documentElement = document && document.documentElement
  // If the browser does support object-fit, we don't need to continue
  if (documentElement && 'objectFit' in documentElement.style !== false && !edgePartialSupport) {
    return true
  }
  return false
}

function hasIntersectionObserver() {
  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
    'isIntersecting' in window.IntersectionObserverEntry.prototype
  ) {
    return true
  }
  return false
}

function hasES2015() {
  try {
    // eslint-disable-next-line
    new Function('(a = 0) => a')
    return true
  } catch (err) {
    return false
  }
}
